import apiFetch from '../apiFetch'

export default function (token, documentEntityType, dossierId) {
  const queryParams = [
    documentEntityType ? `documentEntityType=${documentEntityType}` : null,
    dossierId ? `dossierId=${dossierId}` : null
  ].filter((item) => item !== null).join('&')
  return apiFetch({ endPoint: ('documentHistorical/types') + (queryParams ? ('?' + queryParams) : ''), method: 'GET', token: token })
}
